import axios from "axios";
import getEndpoint from "../getEndpoint";

const ngrokSkipWarning = {headers: {"bypass-tunnel-reminder": "true"} };

export async function AddShipment(credentials: any){
    const response = await axios.post(`${getEndpoint()}/api/Shipment/Add`, credentials, ngrokSkipWarning);
    //console.log(response.data);
    return response.data;
}
